import React, { createContext, useContext, useState, useEffect } from 'react';

// ============================================
// THEME CONTEXT
// ============================================

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Initialize dark mode from localStorage or default to true (dark mode)
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('argus-theme');
    return savedTheme ? savedTheme === 'dark' : true;
  });

  // Update localStorage when theme changes
  useEffect(() => {
    localStorage.setItem('argus-theme', isDarkMode ? 'dark' : 'light');

    // Update document class for global dark mode styling
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const setTheme = (theme) => {
    setIsDarkMode(theme === 'dark');
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export default ThemeContext;
